import fromPairs from 'lodash/fromPairs'
import map from 'lodash/map'

export const randomAlphabeticString = len => {
  let text = ''
  const possible = 'abcdefghijklmnopqrstuvwxyz'

  for (let i = 0; i < len; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }

  return text
}

export function camelCasedObjectToSnakeCasedObject (objToMap) {
  const objKeys = Object.keys(objToMap)
  const formattedObject = {}
  objKeys.forEach(key => {
    const formattedKey = key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)
    formattedObject[formattedKey] = objToMap[key]
  })

  return formattedObject
}

export function snakeCasedObjectToCamelCasedObject (objToMap) {
  const objKeys = Object.keys(objToMap)
  const formattedObject = {}
  objKeys.forEach(key => {
    const formattedKey = key.toLowerCase().replace(/([-_][a-z])/g, letters =>
      letters
        .toUpperCase()
        .replace('-', '')
        .replace('_', '')
    )
    formattedObject[formattedKey] = objToMap[key]
  })
  return formattedObject
}
/* react-final-form does not submit empty form values as outlined here https://github.com/final-form/react-final-form/issues/130
this can cause issues for forms with initial values that need to be cleared.
Instead of having to parse every input for these forms this can be used to format the values */
export function formatFormValuesForSubmit (initialValues, values) {
  return Object.keys(initialValues).reduce((acc, key) => {
    acc[key] = typeof values[key] === 'undefined' ? '' : values[key]
    return acc
  }, {})
}

export const pastYears = (number) => {
  const currentYear = new Date().getFullYear()
  return Array.from({ length: number }, (_, i) => ({
    label: `${currentYear - i}`,
    value: currentYear - i
  }))
}

export const getOrdinalSuffix = (day) => {
  if (day > 3 && day < 21) return 'th'
  switch (day % 10) {
    case 1: return 'st'
    case 2: return 'nd'
    case 3: return 'rd'
    default: return 'th'
  }
}

export const formatValue = (value) => {
  if (value && value >= 0) {
    return value
  }
  return null
}

export const userSelectOptions = (users) => {
  let options = map(users, u => [u.id, `${u.firstName} ${u.lastName}`])
  options = options.sort()
  options = fromPairs(options)
  options.null = '- Unassigned -'
  return options
}

export const parseOrNull = (value, type = 'float') => {
  if (value == null) return null

  return type === 'int'
    ? parseInt(value)
    : parseFloat(value)
}
